export const CLUBLINKS_LIMIT = 25
export const PLAYERS_LIMIT = 25
export const SPONSORS_LIMIT = 10

export const FUNCTIONS_EMULATOR_URL = 'http://localhost:5000/clublink/us-central1'
export const FUNCTIONS_URL = 'https://europe-west1-clublink.cloudfunctions.net'

export const routes = {
  home: 'home',
  manage: 'manage',
  create: 'create',
  edit: 'edit',
  notFound: 'not-found',
  pleaseConnect: 'please-connect'
}
